import { render, staticRenderFns } from "./AvisosApp.vue?vue&type=template&id=30346c2e&"
import script from "./AvisosApp.vue?vue&type=script&lang=js&"
export * from "./AvisosApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports